/**
 * Normalizes the `/user/me` JSON body for Vuex `userData`.
 * Laravel JsonResource responses use `{ data: user }`. When `data` is explicitly
 * `null`, we must not fall back to the envelope object (which would break
 * consumers expecting a user shape).
 */
export function userPayloadFromMeResponseBody (body: unknown): Record<string, unknown> | null {
  if (body == null || typeof body !== 'object' || Array.isArray(body)) {
    return null;
  }

  const record = body as Record<string, unknown>;

  if (Object.prototype.hasOwnProperty.call(record, 'data')) {
    const inner = record.data;

    if (inner != null && typeof inner === 'object' && !Array.isArray(inner)) {
      return inner as Record<string, unknown>;
    }

    return null;
  }

  return record;
}

export function isValidMxUserPayload (user: Record<string, unknown> | null): boolean {
  if (user == null) {
    return false;
  }

  const id = user.id;

  if (typeof id === 'number') {
    return Number.isFinite(id);
  }

  if (typeof id === 'string') {
    return id !== '' && Number.isFinite(Number(id));
  }

  return false;
}
